import $ from "jquery";

function initChosenSelect() {
    // ref: https://harvesthq.github.io/chosen/options.html
    var optionsSingle = {
        allow_single_deselect: false,
        disable_search_threshold: 5,
        placeholder_text_single: "",
        search_contains: true,
        width: "100%"
    };
    var optionsMultiple = {
        disable_search_threshold: 5,
        placeholder_text_single: "",
        search_contains: true,
        width: "100%"
    };

    var singleSelect = $('.chosen-select');
    var multipleSelect = $('.chosen-select-multiple');
    if (singleSelect.length > 0){
        singleSelect.chosen(optionsSingle);
    }
    if (multipleSelect.length > 0){
        multipleSelect.chosen(optionsMultiple);
    }
}

export default initChosenSelect;
